<template>
    <div id="cmswycshowbox" style="position: absolute; z-index: 10000; background-color: white; height: 180px; width: 340px; top: calc(50% - 90px); left: calc(50% - 170px); border: 1px solid rgb(27, 122, 222);">
        <p style="
		line-height: 30px;
		background-color: #0c7df5;
		color: white;
		font-size: 12px;
		padding-left: 10px;
		">
		<span>提示信息</span><span @click="showboxclose(3)" style="float: right;margin-top: 5px;margin-right: 5px;cursor: pointer;">
		<img src="https://aiplugin.5118.com/images/close.png">
		</span></p>
		<p style="vertical-align: middle;text-align: center;margin-top: 20px;
		line-height: 35px;font-size: 16px;">{{ISVIP==6666?'当前提取次数已用尽,如需更多请升级':'需要登录才能使用该功能！'}}</p>
		<p style="vertical-align: middle;text-align: center;font-size: 12px;
		">享更多功能，尽在高级特权！</p>
		<p style="text-align: center;margin-top: 25px;">
		<button style="background-color: #0c7df5;padding: 5px 15px;border: 0;
		border-radius: 3px;color: white;font-size: 14px;cursor: pointer;
		" @click="showboxclose(1)">{{ISVIP==6666?'立即升级':'立即登录'}}</button>
		</p>
    </div>
</template>
<script>
    import Cookies from 'js-cookie'
    export default {
        data(){
            return {
                ISVIP:0
            }
        },
        mounted(){
            this.listenshowbox();
            this.$showboxmessage.addTarget(window.parent, 'parent');
            this.$showboxmessage.targets['parent'].send("_5118_Showbox_IsOK");
        },
        methods:{
            listenshowbox(){
                this.$showboxmessage.listen("_5118_Showbox_IsLevel_Info", (msg) => {
                    this.ISVIP=msg;
                    this.$showboxmessage.addTarget(window.parent, 'parent');
                    this.$showboxmessage.targets['parent'].send("_5118_Showbox_IsLevel_Over",1);
                });
            },
            showboxclose(jumptype){
                if(jumptype===1)
                {
                    this.$showboxmessage.addTarget(window.parent, 'parent');
                    this.$showboxmessage.targets['parent'].send("Send_ShowBox_Close",1);
                }
                else if(jumptype===2)
                {
                    this.$showboxmessage.addTarget(window.parent, 'parent');
                    this.$showboxmessage.targets['parent'].send("Send_ShowBox_Close",2);
                }
                else if(jumptype===3){
                    this.$showboxmessage.addTarget(window.parent, 'parent');
                    this.$showboxmessage.targets['parent'].send("Send_ShowBox_Close",3);
                }
                
            },
            
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/ShowBoxVip.vue